module.exports = "/images/continuereading.svg?5ae9a55e9a3ffa9313449897394c423d";